export const css = {
    container: '_2I8RB8zi',
    ' _key': 'afcpe-theme/afcpe/micro/mc-widgets/hero'
};
export default css;
